import request from './request';
// 智能保养

// 保养设置-列表
/**
 * 获取设置按钮的初始状态
 */
export function getMaintainSwitch() {
    return request('/maintenance/remind/setting', {
        method: 'GET',
    });
}

/**
 * 修改设置按钮的状态
 */
export function setMaintainSwitch(params) {
    return request('/maintenance/remind/setting', {
        method: 'PATCH',
        params,
    });
}

/**
 * 查询保养规则列表
 */
export function getSettingRules(params) {
    return request('/maintenance/remind/rule/list', {
        method: 'GET',
        params,
    });
}

/**
 * 获取该店的服务品牌树
 */
export function getBrandTree(params) {
    return request('/maintenance/remind/brandTree', {
        method: 'GET',
        params,
    });
}

/**
 * 获取本店的车型树结构--与规则无关
 */
export function getPureBrandTree() {
    return request('maintenance/clue/list/brandTree', {
        method: 'GET',
    });
}

/**
 * 新增智能保养规则
 */
export function addRules(params) {
    return request('/maintenance/remind/rule', {
        method: 'POST',
        params,
    });
}

/**
 * 编辑保养规则
 */
export function editRules(params) {
    return request('/maintenance/remind/rule/param', {
        method: 'PUT',
        params,
    });
}

/**
 * 编辑保养规则车型关系
 */
export function editVehicleRules(params) {
    return request('/maintenance/remind/rule/vModel', {
        method: 'PUT',
        params,
    });
}

/**
 * 删除保养规则
 */
export function deleteVehicleRules(ruleId) {
    return request(`/maintenance/remind/rule/${ruleId}`, {
        method: 'DELETE',
    });
}

// 保养设置-详情

/**
 * 获取智能保养规则参数详情
 */
export function getDetailRules(ruleId) {
    return request(`/maintenance/remind/rule/param/${ruleId}`, {
        method: 'GET',
    });
}

/**
 * 获取规则的品牌详情
 */
export function getDetailModels(ruleId, params) {
    return request(`/maintenance/remind/rule/vModel/${ruleId}`, {
        method: 'GET',
        params,
    });
}

/**
 * 删除规则关联的车型
 */
export function deleteVehicleModel(ruleId, vehicleModelId) {
    return request(`/maintenance/remind/rule/${ruleId}/${vehicleModelId}`, {
        method: 'DELETE',
    });
}

// 保养线索--列表

/**
 * 获取保养线索列表
 */
export function getClueList(params) {
    return request('/maintenance/clue/list', {
        method: 'POST',
        params,
    });
}

/**
 * 受理保养
 */
export function getAndJudgeOrder(clueId) {
    return request(`/maintenance/clue/${clueId}/next-maintenance`, {
        method: 'GET',
    });
}

/**
 * 受理保养--更新下一次保养时间和里程
 */
export function updateNextMaintain(clueId, params) {
    return request(`/maintenance/clue/${clueId}/next-maintenance`, {
        method: 'PUT',
        params,
    });
}

/**
 * 受理保养--创建新的预约单
 */
export function createNewAccept(clueId, params) {
    return request(`/maintenance/clue/${clueId}/accept`, {
        method: 'POST',
        params,
    });
}

/**
 * 延迟处理
 */
export function delayHandle(clueId, params) {
    return request(`/maintenance/clue/${clueId}/delay`, {
        method: 'POST',
        params,
    });
}

/**
 * 忽略
 */
export function ignoreHandle(clueId, params) {
    return request(`/maintenance/clue/${clueId}/ignore`, {
        method: 'POST',
        params,
    });
}

/**
 * 详情
 */
export function getClueDetail(clueId) {
    return request(`/maintenance/clue/${clueId}/detail`, {
        method: 'GET',
    });
}

/**
 * 操作记录
 */
export function getClueRecord(clueId, params) {
    return request(`/maintenance/clue/${clueId}/oplog`, {
        method: 'GET',
        params,
    });
}

/**
 * 更新里程
 */
export function updateMileage(vehicleId, params) {
    return request(`/maintenance/clue/${vehicleId}/mileage`, {
        method: 'PATCH',
        params,
    });
}

/**
 * 获取保养备注列表
 */
export function getMaintainRemarks(params) {
    return request('/maintenance/clue/:clueId/remark', {
        method: 'GET',
        params,
    });
}

/**
 * 获取保养备注列表
 */
export function addMaintainRemark(params) {
    return request('maintenance/clue/:clueId/remark', {
        method: 'POST',
        params,
    });
}


/**
 * 编辑线索调度
 */
export function editMaintainDispatch(id, params) {
    return request(`/maintenance/clue/${id}/dispatch`, {
        method: 'PUT',
        params,
    });
}
